import React from 'react';
import LoadingBar from 'react-top-loading-bar';

export default function LoadingView() {
  return <LoadingBar color="#57bc8f" height={5} progress={100} />;
}
